import type {
  AgentDownloadArtifact as ApiArtifact,
  AgentDownloadsResponse,
} from '@/adapters/apiv1.g';
import type {
  AgentDownloadArtifact,
  AgentDownloads,
} from '@/types/core/client';

function extractArtifact(a: ApiArtifact): AgentDownloadArtifact {
  return {
    binary: a.binary ?? '',
    os: a.os ?? '',
    arch: a.arch ?? '',
    filename: a.filename ?? '',
    path: a.path ?? '',
    url: a.url ?? '',
    bundleURL: a.bundle_url ?? undefined,
    checksumAlgorithm: a.checksum_algorithm ?? undefined,
    checksumFile: a.checksum_file ?? undefined,
    checksumPath: a.checksum_path ?? undefined,
    checksumURL: a.checksum_url ?? undefined,
  };
}

export function extractAgentDownloads(
  model: AgentDownloadsResponse
): AgentDownloads {
  return {
    agent: (model.agent ?? []).map(extractArtifact),
    agentd: (model.agentd ?? []).map(extractArtifact),
  };
}
